import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import Notification from "../../elements/notification/Notification";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { TextField } from "@material-ui/core";
import DefaultFeeEditForm from "./DefaultFeeEditForm";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { StyledFeeDetailsWrapper } from "../../fee/styledFee";

const DefaultFeeDetailsContainer = ({ match }) => {
  const { t } = useTranslation("defaultFeePage");
  const [fee, setFee] = useState();
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/default-fees/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setFee(response.data);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  }, []);

  if (!fee) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (fee.length === 0) {
    return <Alert severity="warning">{t("details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{fee.baseFee.paymentSystem.name} ({fee.baseFee.service.name}) - {t("details.meta.title")} {fee.baseFee.service.name} • eXsoft.io</title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.paymentSystem")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.service")}
                  type="text"
                  value={getServiceNameWithNickname(fee.baseFee.service.name, fee.baseFee.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.paymentSystem")}
                  type="text"
                  value={fee.baseFee.paymentSystem.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.currency")}
                  type="text"
                  value={fee.baseFee.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.type")}
                  type="text"
                  value={fee.baseFee.type}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.fee")}
              </StyledBlockLabel>
              <DefaultFeeEditForm
                fee={fee}
                notification={notification}
                setNotification={setNotification}
                url="/api/default-fees/"
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default DefaultFeeDetailsContainer;